import type { Location } from "react-router";
import { ROUTE_CHANGED } from "state/routeChange";
import { currentLocation } from "routes/currentLocation";

export interface LocationState {
  pathname: string;
  search: string;
  hash: string;
}

const buildState = ({
  pathname,
  search,
  hash
}: Pick<Location, "pathname" | "search" | "hash">): LocationState => ({
  pathname,
  search,
  hash
});

const initialState: LocationState = buildState(currentLocation());

interface RouteChangedAction {
  type: typeof ROUTE_CHANGED;
  payload: { location: Location };
}

type LocationAction = RouteChangedAction | { type: string };

/**
 * Mirrors the router location into redux so navigation changes the store state
 * reference. Without this, react-redux's strict areStatesEqual check bails out
 * on query-only navigation and connected components never re-run
 * mapStateToProps (this is what connected-react-router used to provide).
 */
export default (
  state: LocationState = initialState,
  action: LocationAction
): LocationState => {
  if (action.type === ROUTE_CHANGED) {
    return buildState((action as RouteChangedAction).payload.location);
  }
  return state;
};
